// extracted by mini-css-extract-plugin
export default {"container_home":"home_container_home__pJQs4","helloworld":"home_helloworld__sCLy-"};